export default __webpack_public_path__ + "static/media/AcceleronsGallery_4.0bf26e60.JPG";